import { useTranslation } from "react-i18next";

export default function Manifesto() {
  const { t } = useTranslation();
  return (
    <section className="panel manifesto" id="belief">
      <span
        className="panel-accent mono"
        aria-hidden="true"
        data-parallax="0.55"
        style={{
          fontSize: "clamp(160px, 26vw, 340px)",
          fontWeight: 500,
          lineHeight: 1,
          color: "color-mix(in srgb, var(--accent) 12%, transparent)",
          letterSpacing: "-.04em",
          top: "50%",
          left: "50%",
          marginLeft: "-50%",
          marginTop: "-0.6em",
        }}
      >
        FY
      </span>
      <p
        className="manifesto-text"
        data-words
        dangerouslySetInnerHTML={{ __html: t("manifesto") }}
      />
    </section>
  );
}